import axios from "../utils/axios";

export const getEquipmentNotes = (payload) => {
    return axios.post(`/EquipmentInfo/GetPagedMultipleChoices?PageSize=${payload.payload.pageSize}&PageNumber=${payload.payload.currentPage}`, payload.payload.data);
};

export const addEquipmentNote = (payload) => {
    return axios.post(`/Equipment/AddEquipmentNote`, payload);
};

export const updateEquipmentNote = (payload) => {
    return axios.post(`/Equipment/UpdateEquipmentNoteById`, payload);
};

export const deleteEquipmentNote = (payload) => {
    return axios.post(`/Equipment/DeleteEquipmentNoteById?id=${payload}`);
};